<template>
    <div class="user-company-edit">
        <data-form title="Edit Company Association"
                   tag="user-company-edit"
                   save-button-label="Save"
                   :field-model="companyUser"
                   :field-groups="fieldGroups"
                   :disabledFields="disabledFields"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/user/view/${userId}`"
                   :load-model-instance="loadModelInstance"
                   submit-success-message="User company info updated"
                   submit-error-message="Error updating">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import CompanyUser from '@/models/CompanyUser'

export default Vue.extend({
    name: 'CompanyUserSetup',
    props: {
        userId: Number,
        companyUserId: Number,
    },
    data () {
        return {
            companyUser: CompanyUser,
            disabledFields: ['user_full_name', 'company_name']
        }
    },
    computed: {
        fieldGroups () {
            return [['is_company_admin']]
        },
    },
    methods: {
        async loadModelInstance () {
            return this.$api.getItem(this, 'company-user', this.companyUserId)
                .then((companyUser) => {
                    return this.$api.getItem(this, 'user', companyUser.user_id)
                        .then((user) => {
                            companyUser.user_full_name = user.full_name
                            return companyUser
                        })
                        .then((companyUser) => {
                            return this.$api.getItem(this, 'company', companyUser.company_id)
                                .then((company) => {
                                    companyUser.company_name = company.name
                                    return companyUser
                                })
                        })
                })
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'company-user', modelInstance)
                .then(async (response) => {
                    this.$router.push(`/user/view/${this.userId}`)
                })
        }
    },
})

</script>
